import React, { ReactElement, useState } from "react";
// import { useChangePasswordMutation } from "../../../__generated__/legacy";

import "./PasswordChange.css";

interface EditPassword {
    oldPass: string;
    newPass: string;
    confirm: string;
}

export default function PasswordChange(): ReactElement {
    const defaultData = { oldPass: "", newPass: "", confirm: "" };
    const [passwordData, setPasswordData] = useState<EditPassword>(defaultData);
    const [pwdValid, setPwdValid] = useState<string>("");
    const [success, setSuccess] = useState<boolean>(false);
    // const [changePassword] = useChangePasswordMutation();

    function hasSymbolOrNumber(password: string): boolean {
        return !!password.match(/[\W_0-9]/);
    }

    function hasUpperCase(password: string): boolean {
        return !!password.match(/[A-Z]/);
    }

    function hasLowerCase(password: string): boolean {
        return !!password.match(/[a-z]/);
    }

    function validatePassword(): boolean {
        if (passwordData.newPass.length < 7) {
            setPwdValid("New password must have 7 or more characters");
        } else if (!hasUpperCase(passwordData.newPass)) {
            setPwdValid("Password must contain at least one uppercase character");
        } else if (!hasLowerCase(passwordData.newPass)) {
            setPwdValid("Password must contain at least one lowercase character");
        } else if (!hasSymbolOrNumber(passwordData.newPass)) {
            setPwdValid("Password must contain one symbol or number");
        } else if (passwordData.newPass !== passwordData.confirm) {
            setPwdValid("Passwords must match");
        } else {
            setPwdValid("");
            return true;
        }
        return false;
    }

    function handleChange(evt: React.ChangeEvent<HTMLInputElement>) {
        const { name, value } = evt.target;
        setPasswordData(data => ({ ...data, [name]: value }));
        setPwdValid("");
        setSuccess(false);
    }

    async function handleSubmit(evt: React.FormEvent<HTMLFormElement>) {
        evt.preventDefault();
        if (validatePassword()) {
            const { oldPass, newPass } = passwordData;
            // const resp = await changePassword({ variables: { oldPassword: oldPass, newPassword: newPass } });
            setPasswordData(defaultData);
            // if (resp.data?.changePassword === "SUCCESS") {
            //     setSuccess(true);
            // } else {
            //     setPwdValid("Old password was not valid");
            // }
        }
    }

    return (
        <div
            data-test="change-password"
            className="password-container p-5 mx-auto my-5 w-50"
        >
            <div className="w-100">
                {pwdValid && (
                    <div className="alert alert-danger" data-test="bad-edit" role="alert">
                        {pwdValid}
                    </div>
                )}
                {success && (
                    <div className="alert alert-success" data-test="bad-edit" role="alert">
                        Success!
                    </div>
                )}
                <form className="" onSubmit={handleSubmit}>
                    <div className="form-group ">
                        <label htmlFor="old-pass" className="w-100">
                            Old Password
                            <input
                                type="password"
                                onChange={handleChange}
                                id="old-pass"
                                name="oldPass"
                                data-test="old-pass"
                                value={passwordData.oldPass}
                                className="form-control"
                            />
                        </label>
                    </div>
                    <div className="form-group ">
                        <label htmlFor="new-pass" className="w-100">
                            New Password
                            <input
                                type="password"
                                onChange={handleChange}
                                id="new-pass"
                                name="newPass"
                                data-test="new-pass"
                                value={passwordData.newPass}
                                className="form-control"
                            />
                        </label>
                    </div>
                    <div className="form-group ">
                        <label htmlFor="confirm" className="w-100">
                            Confirm
                            <input
                                type="password"
                                onChange={handleChange}
                                id="confirm"
                                name="confirm"
                                data-test="confirm"
                                value={passwordData.confirm}
                                className="form-control"
                            />
                        </label>
                    </div>
                    <button
                        data-test="submit-btn"
                        type="submit"
                        className="btn btn-md btn-primary submit-btn mt-3 d-block mx-auto"
                    >
                        Submit
                    </button>
                </form>
            </div>
        </div>
    );
}
